// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"_3vQqTUyW","mediaContainer":"_2QJZ2moG","content":"U7bcRtXd","title":"_1v8bOQCE","text":"_2TAxFlW1","textAndMedia":"_2kiPN3bE","isLeft":"_3NHVurcd"};